import { SiteGroupsService } from './../services/site-groups.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { SiteGroup } from '@classes/site-group';

@Injectable()
export class SiteGroupsResolver  {
    constructor(private siteGroupsSrv: SiteGroupsService, private uiSrv: UiService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SiteGroup[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);
        return this.siteGroupsSrv.getList()
        .pipe(tap(() => { this.uiSrv.routeLoadingStateChanged.next(false); }));
    }
}
